/**
 * @param {angular.IScope} $scope
 * @param {angular.ui.IStateService} $state
 * @param {angular.material.IBottomSheetService} $mdBottomSheet
 * @param {ChargeRequestService} ChargeRequestService
 * @param {$Loading} $Loading
 * @param {$message} $message
 * @param {boolean} canQueue
 * @param {string} siteId
 * @param {any[]} availableChargingPoints
 */
// @ts-ignore
function ReportIssueController($scope, $state, $mdBottomSheet, ChargeRequestService, $Loading, $message, canQueue, siteId, availableChargingPoints) {
    this.$scope = $scope;
    this.$state = $state;
    this.$mdBottomSheet = $mdBottomSheet;
    this.chargeRequestService = ChargeRequestService;
    this.$Loading = $Loading;
    this.$message = $message;
    this.canQueue = canQueue;
    this.siteId = siteId;
    // for (let i = 0; i < 100; i++) {
    //     if (availableChargingPoints.length > 0) {
    //         let item = JSON.parse(JSON.stringify(availableChargingPoints[0]));
    //         delete item.$$hashKey;
    //         item.ChargingPointId = item.ChargingPointId + i;
    //         item.ChargingPointName = item.ChargingPointName + i;
    //         availableChargingPoints.push(item);
    //     }

    // }

    this.availableChargingPoints = availableChargingPoints;
    this.chargingPointName = "<span>" + this.availableChargingPoints.map((item) => item.ChargingPointName).join(", ") + "</span>";



    this.init();
}
ReportIssueController.$inject = ['$scope', '$state', '$mdBottomSheet', 'ChargeRequestService', '$Loading', '$message', 'canQueue', 'siteId', 'availableChargingPoints'];
ReportIssueController.prototype = {
    canQueue: false,
    pageNumber: 0,
    feedback: '',
    chargingStation: null,
    init() {
        this.pageNumber = 0;

    },
    cannotConnectToAnyCharger() {
        if (this.availableChargingPoints.length === 0) {
            this.noChargingPointAvailable();
        } else {
            this.pageNumber = 1;
        }
    },

    /**
     * @param {any} [result]
     */
    close(result) {
        this.$mdBottomSheet.hide(result);
    },

    noChargingPointAvailable() {
        this.close('NoChargingPointAvailable');
    },

    confirmDisableCharger() {
        this.chargeRequestService.reportChargingPointIssue({
            "SiteId": this.siteId,
            "IssueType": "NoChargingPointAvailable",
            "MarkChargingPointsAsNotAccessible": true,
            "ChargingPointIds": this.availableChargingPoints.map((e) => e.ChargingPointId),
        })
            .finally(this.$Loading.blockUI())
            .then(() => {
                this.noChargingPointAvailable();
            }, this.$message.error);
    },


    reportChagerIssue() {
        this.pageNumber = 2;
    },

    cancel() {
        this.close();
    },

    /**
     * @param chargerIssueForm {angular.IFormController}
     */
    confirmReportCharger(chargerIssueForm) {
        if(!chargerIssueForm.$valid){
            if(chargerIssueForm.chargingStation){
                chargerIssueForm.chargingStation.$setTouched();
            }
            return;
        }
        // @ts-ignore
        if (!this.chargingStation || !this.chargingStation.ChargingPointId) {
            this.$message.error("Please select a charging point");
            return;
        }
        this.chargeRequestService.reportChargingPointIssue({
            "SiteId": this.siteId,
            "IssueType": "SpecificChargingPointIssue",
            "Comment": this.feedback,
            "MarkChargingPointsAsNotAccessible": true,
            // @ts-ignore
            "ChargingPointIds": [this.chargingStation.ChargingPointId],
        })
            .finally(this.$Loading.blockUI())
            .then(() => {
                this.specificChargingPointIssue();
            }, this.$message.error);
    },

    specificChargingPointIssue() {
        this.close('SpecificChargingPointIssue');
    },

    onOpenChargingStation() {
        $("body").addClass("open-charging-station");
    },

    onCloseChargingStation() {
        $("body").removeClass("open-charging-station");
    }
};
angular.module('internal.parkingarea').controller('ReportIssueController', ReportIssueController)